import { FC } from "react";
import cls from "classnames";
import styles from "./index.module.scss";
import { Root, createRoot } from "react-dom/client";
import { useAtomValue } from "jotai";

import { isWorkLeftPanelOpenAtom } from "@/atom/drawBoard";

type ToastProps = {
  className?: string;
  message: string;
};

const Toast: FC<ToastProps> = ({ message, className }) => {
  const isWorkLeftPanelOpen = useAtomValue(isWorkLeftPanelOpenAtom);
  return (
    <div
      className={cls({
        [styles.toast]: true,
        [className!]: className,
        [styles.leftOpen]: isWorkLeftPanelOpen,
      })}
    >
      {message}
    </div>
  );
};

// Toast ID 计数器
let toastIdCounter = 0;

// 存储需要卸载的队列
const unmountQueue: Set<Root> & { timer?: NodeJS.Timeout } = new Set<Root>();

/** 卸载弹窗 */
const unmountToast = () => {
  try {
    unmountQueue.forEach((root) => root.unmount());
    unmountQueue.clear();
  } catch (error) {
    // 处理卸载异常情况
    console.log("error", error);
  }

  unmountQueue.timer && clearTimeout(unmountQueue.timer);
  unmountQueue.timer = undefined;

  // 清理所有 toast 容器，避免在同一容器上重复创建 root
  const toastContainers = document.querySelectorAll('[id^="toast"]');
  toastContainers.forEach(container => container.remove());
};

/** 弹出来的toast */
const messageToast = (
  props: Partial<ToastProps>,
  duration = 2000
) => {
  // 每次创建新容器，使用唯一 ID
  const id = `toast-${toastIdCounter++}`;
  const container = document.createElement("div");
  container.setAttribute("id", id);
  document.body.appendChild(container);

  const root = createRoot(container);
  root.render(<Toast {...(props as ToastProps)} />);

  // 单独清理这个 root
  const cleanup = () => {
    try {
      root.unmount();
      container.remove();
    } catch (error) {
      console.error("Toast cleanup error:", error);
    }
  };

  // 设置定时清理
  const timer = setTimeout(cleanup, duration);
  return timer;
};

export const message = {
  info: (message: string, duration?: number) =>
    messageToast({ message }, duration),
  destroy: unmountToast,
};

export default Toast;
